import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=45a39c80&scoped=true"
import script from "./branch.js?vue&type=script&lang=js&external"
export * from "./branch.js?vue&type=script&lang=js&external"
import style0 from "./branch.vue?vue&type=style&index=0&id=45a39c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a39c80",
  null
  
)

export default component.exports